// import { useCallback } from 'react';

export interface VerificationData {
  entity: string;
  beneficialOwner: string;
  pep: string;
  sanction: string;
  adverseMedia: string;
}

export interface EntityDetails {
  companyName: string;
  abn: string;
  acn: string;
  registration: string;
  address: string;
  industry: string;
}

export interface BeneficialOwner {
  name: string;
  role: string;
  percentage: string;
  idvStatus: string;
}

export interface ProfileData {
  name: string;
  abn: string;
  acn: string;
  verified: boolean;
  certificateId: string;
  issued: string;
  verification: VerificationData;
  riskRating: string;
  ecdStatus: string;
  entityDetails: EntityDetails;
  beneficialOwners: BeneficialOwner[];
}

export const useC2ProfileData = (): ProfileData => {
  const profileData: ProfileData = {
    name: 'ABC Holdings Pty Ltd',
    abn: 'XX XXX XXX XXX',
    acn: '000 000 000',
    verified: true,
    certificateId: 'IDEN.0AAA.Aaaa.AAaA.A0a0',
    issued: '19/01/2025 11:53 AM AEDT',
    verification: {
      entity: 'Pass',
      beneficialOwner: 'Pass',
      pep: 'No Match',
      sanction: 'No Match',
      adverseMedia: 'No Match',
    },
    riskRating: 'LOW RISK',
    ecdStatus: 'Not Required',
    entityDetails: {
      companyName: 'ABC Holdings Pty Ltd',
      abn: 'XX XXX XXX XXX',
      acn: '000 000 000',
      registration: '01/01/2020',
      address: '123 Business St, Sydney NSW 2000',
      industry: 'Professional Services',
    },
    beneficialOwners: [
      { name: 'John Smith', role: 'Director', percentage: '50%', idvStatus: 'Verified' },
      { name: 'Jane Doe', role: 'Director', percentage: '30%', idvStatus: 'Verified' },
      { name: 'Michael Brown', role: 'S/holder', percentage: '20%', idvStatus: 'Verified' },
    ],
  };

  // Handlers for future implementation
  // const handleDownloadPDF = useCallback(() => {
  //   alert('📥 Downloading certificate PDF...');
  // }, []);
  //
  // const handlePrint = useCallback(() => {
  //   alert('🖨️ Opening print dialog...');
  // }, []);
  //
  // const handleEmail = useCallback(() => {
  //   alert('📧 Opening email dialog...');
  // }, []);
  //
  // const handleRequestReScreening = useCallback(() => {
  //   alert('🔄 Re-screening requested successfully');
  // }, []);

  return profileData;
};
